<div class="lprViewStagesContainer">
  <div class="stageView">
    <div class="stageContent" #plateResults>
      <div id="banners">
        <!-- SDM Banner Logic -->
        <ng-container *ngIf="sourceAndDeviceManagementEnabled">
          <div *ngIf="!isLoading && hasLoaded && shouldShowNoResultsBanner()">
            <fs-banner-message id="noResultsBanner" data-testid="alpr-no-results-banner" [message]="MESSAGES.NO_RESULTS | t" state="info">
            </fs-banner-message>
          </div>
          <ng-container
            *ngIf="!isLoading && hasLoaded && results.length > 0 && hasBoundingBoxParams"
          >
            <fs-banner-message
              id="searchBoundaryBanner"
              [message]="MESSAGES.SEARCH_BOUNDARY | t"
              state="info"
            >
            </fs-banner-message>
          </ng-container>
        </ng-container>

        <!-- Non-SDM Banner Logic -->
        <ng-container *ngIf="!sourceAndDeviceManagementEnabled">
          <ng-container *ngIf="errors.length > 0 && !isLoading" class="errorBanner">
            <fs-banner-message
              class="errorBanner"
              *ngFor="let error of errors"
              [message]="error | t"
              state="error"
            >
            </fs-banner-message>
          </ng-container>
          <ng-container
            *ngIf="warnings && warnings.length > 0 && !isLoading && !isReviewingPlates"
            class="warningBanner"
          >
            <fs-banner-message
              class="warningBanner"
              *ngFor="let warning of warnings"
              [message]="warning.message | t"
              state="warning"
            >
            </fs-banner-message>
          </ng-container>
          <ng-container
            *ngIf="
              !isLoading &&
              hasLoaded &&
              !activeProvider &&
              hasProviderWarnings &&
              !isReviewingPlates
            "
          >
            <fs-banner-message
              class="infoBanner"
              [message]="MESSAGES.PROVIDER_UNSUPPORTED_FILTERS | t"
              state="info"
            >
            </fs-banner-message>
          </ng-container>
          <div
            *ngIf="
              !isLoading &&
              hasLoaded &&
              ((activeProvider && results.length < 1) ||
                (!activeProvider && areAllProvidersEmpty)) &&
              errors.length === 0
            "
          >
            <fs-banner-message id="noResultsBanner" [message]="MESSAGES.NO_RESULTS | t" state="info">
            </fs-banner-message>
          </div>
          <ng-container *ngIf="!isLoading && hasLoaded && hasFlockV3Results && results.length > 0">
            <fs-banner-message
              id="flockV3LimitationsBanner"
              [message]="MESSAGES.FLOCK_V3_LIMITATIONS | t"
              state="info"
            >
            </fs-banner-message>
          </ng-container>
          <ng-container
            *ngIf="!isLoading && hasLoaded && results.length > 0 && hasBoundingBoxParams"
          >
            <fs-banner-message
              id="searchBoundaryBanner"
              [message]="MESSAGES.SEARCH_BOUNDARY | t"
              state="info"
            >
            </fs-banner-message>
          </ng-container>
        </ng-container>
      </div>
      <div id="defaultView" *ngIf="!isLoading && !hasLoaded && this.results.length === 0">
        <div class="licenseIconContainer">
          <img src="/assets/fusus-icons/SVG/LPR_empty.svg" />
          <div>
            <span class="searchText">{{ 'alpr.enterSearchToStart' | t }}</span>
          </div>
        </div>
      </div>

      <div id="searchingView" *ngIf="isLoading && !hasLoaded">
        <div class="loadingIndicator">
          <div>
            <mat-spinner color="white" diameter="100" mode="indeterminate"> </mat-spinner>
          </div>
          <div class="searchingContainer">
            <span class="searchText">{{ 'alpr.searching' | t }}</span>
            <sn-button color="danger" class="cancelButton" (click)="cancel()">
              {{ 'common.cancelSearch' | t }}
            </sn-button>
          </div>
        </div>
      </div>

      <div
        class="plate-results"
        [class.table-view]="mode === 'list'"
        *ngIf="!isLoading && hasLoaded"
      >
        <ng-container *ngIf="mode === 'cards'">
          <fs-fleet-query-plate-card
            *ngFor="let plate of results; let i = index"
            [inputPlate]="plate"
            (click)="onPlateClick(plate)"
            [selected]="selectedPlate?.id === plate.id"
            (hideDetails)="onHideDetails($event)"
            [warningTooltip]="getPlateWarningInfoTooltip && getPlateWarningInfoTooltip(plate)"
            [isReviewingPlates]="isReviewingPlates"
            (viewLargerClicked)="openLightboxFunction($event)"
            [tabindex]="selectedCardIndex === i ? 0 : -1"
            (focus)="focusPlate($event, i)"
          ></fs-fleet-query-plate-card>
        </ng-container>
        <ng-container *ngIf="mode === 'list' && results.length > 0">
          <fs-fleet-query-table
            [items]="results"
            [columns]="columns"
            [actions]="actions"
            [selectedPlate]="selectedPlate"
            [getPlateWarningInfoTooltip]="getPlateWarningInfoTooltip"
            [isReviewingPlates]="isReviewingPlates"
            (plateClicked)="onPlateClick($event)"
          ></fs-fleet-query-table>
        </ng-container>
      </div>
    </div>

    <div class="footerContainer">
      <div class="footer">
        <div class="left">
          <div>{{ 'alpr.itemsPerPage' | t }}</div>
          <mat-select
            [(ngModel)]="pageLimit"
            (selectionChange)="onPaginationChange()"
            [placeholder]="pageLimit"
          >
            <mat-option *ngFor="let option of paginationOptions" [value]="option.toString()">{{
              option
            }}</mat-option>
          </mat-select>
        </div>
        <div class="right">
          <button
            [matTooltip]="'common.firstPage' | t"
            mat-icon-button
            (click)="firstPage()"
            [disabled]="isPreviousPageDisabled || isLoading"
          >
            <sn-icon fontSet="fas" fontIcon="fa-step-backward"></sn-icon>
          </button>
          <button
            data-testid="previousButton"
            [matTooltip]="'common.previous' | t"
            mat-icon-button
            (click)="previousPage()"
            [disabled]="isPreviousPageDisabled || isLoading || results.length < 1"
          >
            <sn-icon fontSet="fas" fontIcon="fa-caret-left"></sn-icon>
          </button>
          <button data-testid="currentPageButton" [matTooltip]="'common.current' | t" mat-icon-button disabled>{{ page }}</button>
          <button
            data-testid="nextButton"
            [matTooltip]="'common.next' | t"
            mat-icon-button
            (click)="nextPage()"
            [disabled]="isNextPageDisabled || isLoading || results.length < 1"
          >
            <sn-icon fontSet="fas" fontIcon="fa-caret-right"></sn-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
